import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Seo, { SITE_URL } from "@/components/feature/Seo";
import { homeFaqs } from "@/mocks/faqs";
import { siteInfo } from "@/mocks/site";
import { allPosts } from "@/lib/content";
import Hero from "@/pages/home/components/Hero";
import CategoryStrip from "@/pages/home/components/CategoryStrip";
import EditorPick from "@/pages/home/components/EditorPick";
import RecommendGrid from "@/pages/home/components/RecommendGrid";
import HotBoard from "@/pages/home/components/HotBoard";
import CollectionSection from "@/pages/home/components/CollectionSection";
import FaqPreview from "@/pages/home/components/FaqPreview";
import SubscribeCta from "@/pages/home/components/SubscribeCta";

export default function Home() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: siteInfo.name,
      url: SITE_URL,
      description: siteInfo.intro,
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: `${SITE_URL}/category/mingchangmian?keyword={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: siteInfo.name,
      url: SITE_URL,
      email: siteInfo.email,
      description: siteInfo.slogan,
      foundingDate: String(siteInfo.startYear),
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: homeFaqs.map((faq) => ({
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: { "@type": "Answer", text: faq.answer },
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "今日推荐内容",
      itemListElement: allPosts.slice(0, 6).map((post, index) => ({
        "@type": "ListItem",
        position: index + 1,
        url: `${SITE_URL}/post/${post.id}`,
        name: post.title,
      })),
    },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <Seo
        title="瓜乐圈 — 福利吃瓜名场面、爆笑高能与小甜瓜乐子合集"
        description="瓜乐圈是轻松向的福利吃瓜内容站，聚合名场面、爆笑高能、小甜瓜与乐子合集，专治无聊时刻，碎片时间随手刷一刷。"
        keywords="福利吃瓜,福利吃瓜名场面,福利吃瓜爆笑,小甜瓜,乐子合集"
        path="/"
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        <Hero />
        <CategoryStrip />
        <EditorPick />
        <RecommendGrid />
        <HotBoard />
        <CollectionSection />
        <FaqPreview />
        <SubscribeCta />
      </main>
      <Footer />
    </div>
  );
}